import { IconExternalLink, IconSearch } from "@tabler/icons-react";
import { getRouteApi, useNavigate } from "@tanstack/react-router";
import { css } from "styled-system/css";
import { Box, Center, Container, Flex, Grid, GridItem } from "styled-system/jsx";
import { useDebouncedCallback } from "use-debounce";
import { EmptyState, Icon, Input, Pagination } from "~/components";

const getRoute = getRouteApi("/_layout/export-info/");

export const List = () => {
  const result = getRoute.useLoaderData();
  const params = getRoute.useSearch();
  const navigate = useNavigate({ from: "/export-info" });

  const debouncedSearch = useDebouncedCallback((value: string) => {
    navigate({
      search: (prev) => ({ ...prev, page: 1, keyword: value }),
      replace: true,
    });
  }, 500);

  return (
    <Container maxW="7xl" mt={10} mb={20}>
      <Flex flexDir="column" gap="10">
        <h1
          className={css({
            textStyle: "h6",
            color: "disabled",
            fontWeight: "bold",
          })}
        >
          Informasi Ekspor
        </h1>
        <Box position="relative" role="group" tabIndex={1}>
          <Icon
            pos="absolute"
            height="54px"
            display="flex"
            flexDir="column"
            alignItems="center"
            left={4}
            className={css({ color: "primary" })}
          >
            <IconSearch />
          </Icon>
          <Input
            borderRadius="12"
            size="md"
            pl="40px"
            minW={{ base: "0", md: "412px" }}
            width="full!"
            placeholder="Cari informasi ekspor"
            defaultValue={params.keyword}
            onChange={(e) => debouncedSearch(e.target.value)}
          />
        </Box>
        {result.data.list.length === 0 ? (
          <Center>
            <EmptyState
              title="Belum ada informasi ekspor"
              description="Tautan informasi ekspor akan muncul di halaman ini."
            />
          </Center>
        ) : (
          <Flex gap="40px" flexDir="column">
            <Grid gridTemplateColumns={{ base: "1", sm: "2", lg: "3" }} gap="24px">
              {result.data.list.map((v) => (
                <GridItem key={v.id}>
                  <a
                    href={v.link || "#"}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={css({
                      display: "flex",
                      flexDirection: "column",
                      gap: "3",
                      h: "full",
                      border: "1px solid #E4E7EC",
                      borderRadius: "16px",
                      p: "20px",
                      transition: "all 0.15s",
                      _hover: { borderColor: "primary", boxShadow: "shadow_2" },
                    })}
                  >
                    <p className={css({ textStyle: "lg", fontWeight: "bold", color: "secondary.darken8" })}>
                      {v.name}
                    </p>
                    <Flex alignItems="center" gap="2" color="primary" mt="auto">
                      <p className={css({ textStyle: "sm", fontWeight: "medium" })}>Kunjungi</p>
                      <Icon width="16px" height="16px">
                        <IconExternalLink />
                      </Icon>
                    </Flex>
                  </a>
                </GridItem>
              ))}
            </Grid>
            <Center>
              <Pagination
                count={result.data.paging.count}
                pageSize={result.data.paging.limit}
                siblingCount={0}
                page={result.data.paging.page}
                onPageChange={(v) => {
                  navigate({ search: (prev) => ({ ...prev, page: v.page }) });
                }}
              />
            </Center>
          </Flex>
        )}
      </Flex>
    </Container>
  );
};
